import { render, staticRenderFns } from "./handheldDownload.vue?vue&type=template&id=76230c38&scoped=true&"
import script from "./handheldDownload.vue?vue&type=script&lang=js&"
export * from "./handheldDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76230c38",
  null
  
)

export default component.exports